var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{attrs:{"max-width":"600"}},[_c('v-card-text',{staticClass:"entire-field"},[_vm._v("\n          "+_vm._s(_vm.field)+"\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cf795b8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/PEntireField.vue
// module id = 1301
// module chunks = 1